import * as Sentry from '@sentry/react';
import posthog from 'posthog-js';

import { bootstrapConfig, globalConfig } from '~src/context/config';

export const initErrorTracking = () => {
  const environment = process.env.ENV;

  if (environment === 'development' || environment === 'local') {
    return;
  }

  const version = `${process.env.BUILD_REV || 'default'}`;
  const sentryProjectID = parseInt(globalConfig.sentryDsn.split('/').reverse()[0]);

  Sentry.init({
    dsn: globalConfig.sentryDsn,
    environment,
    release: version,
    // LocalStorage ignored only because we had errors coming from outside our code
    // if you happen to use localstorage internally, remove this line
    ignoreErrors: [
      'TypeError: LOCAL_STORAGE is null',
      `Could not load "util".`,
      'google map initialization error (not loaded)',
      'Non-Error promise rejection captured with value',
      // Random plugins/extensions
      'top.GLOBALS',
      // google analytics/gtm junk
      /change_ua/,
      'Cannot redefine property: googletag',
      'ResizeObserver loop limit exceeded',
    ],
    denyUrls: [
      // chrome extensions
      /extensions\//i,
      /^chrome:\/\//i,
      /^chrome-extension:\/\//i,
    ],
    tracesSampler: context => {
      if (!context.location?.pathname.includes('checkout.html')) {
        return 0;
      }

      if (!bootstrapConfig.fullSentryTracing) {
        return 0.007;
      }

      return 0.5;
    },
    integrations: [
      posthog.sentryIntegration({ organization: 'shipwallet', projectId: sentryProjectID }),
      Sentry.browserTracingIntegration({
        beforeStartSpan: context => ({
          ...context,
          name: `${location.pathname.split('/').reverse()[0]} load`,
        }),
      }),
    ],
  });

  Sentry.setTag('session_ID', bootstrapConfig.sessionId);
  Sentry.setTag('site', bootstrapConfig.creator);
  Sentry.setTag('release_label', 'v4');
};
